import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledContainer = styled.div `
    padding: 0 15px;
    width: 100%;
    max-width: ${props => {
    if (props.fullWidth === true) {
        return 'none';
    }
    return '1600px';
}};
`;
const Container = ({ children, className, fullWidth, largeGutter, maxWidth, }) => (_jsx(StyledContainer, { className: className, fullWidth: fullWidth, largeGutter: largeGutter, maxWidth: maxWidth, children: children }));
export default Container;
